var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewPencilEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_16519111",
    clipPath: "url(#clip0_38317_60257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.48235 2.81641L1.54965 9.7496C1.51478 9.78458 1.48959 9.82876 1.4776 9.87623L0.709176 12.9605C0.68619 13.0534 0.713473 13.1521 0.781231 13.2199C0.832499 13.2711 0.902356 13.2995 0.973812 13.2995C0.995698 13.2995 1.01808 13.2968 1.03987 13.2913L4.12416 12.5228C4.17223 12.5108 4.2159 12.4857 4.25078 12.4508L11.1841 5.51813L8.48235 2.81641Z",
    fill: "#868D96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9008 1.87126L12.1291 1.09954C11.6133 0.583758 10.7144 0.584258 10.1992 1.09954L9.25391 2.04485L11.9555 4.74648L12.9008 3.80116C13.1585 3.54362 13.3004 3.20083 13.3004 2.83626C13.3004 2.47169 13.1585 2.1289 12.9008 1.87126Z",
    fill: "#868D96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38317_60257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2632,
    height: 14,
    fill: "white",
    transform: "translate(0.368164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPencilEdit);
export default __webpack_public_path__ + "static/media/newPencilEdit.2dbfc4ce3533cd21ca5c64024ae9a362.svg";
export { ForwardRef as ReactComponent };